import PaymentAgreements from './PaymentAgreements';
export default PaymentAgreements;